import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const paperClasses = tv({
  base: ["Paper_Root", "bg-white", "rounded-xl", "overflow-hidden", "block"],
  variants: {
    variant: {
      elevation: ["shadow-md"],
      outlined: ["border", "border-gray-300", "shadow-none"],
    },
    square: {
      true: "rounded-none",
    },
    elevation: {
      sm: "shadow-sm",
      md: "shadow-md",
      lg: "shadow-lg",
      xl: "shadow-xl",
      none: "shadow-none",
    },
  },
  defaultVariants: {
    variant: "elevation",
    elevation: "md",
  },
});

export type PaperVariants = VariantProps<typeof paperClasses>;
